export const transformHierarchyWithLevel = (nodes: Record<string, any>[], level: number): Record<string, any>[] => {
    const tmpParentNodes = [];

    // init parent nodes
    nodes.forEach((node) => {
        let parent;
        if (node.classificationLevel === level) {
            parent = { ...node, classificationChildren: [] };
            tmpParentNodes.push(parent);
        }
    });

    // add children in parent nodes
    tmpParentNodes.forEach((parentNode) => {
        nodes.forEach((node) => {
            if (node.classificationAncestors.some((ancestor) => ancestor === parentNode.classificationCode)) {
                parentNode.classificationChildren.push(node);
            }
        });
    });

    // compute parent total sum according to children total
    tmpParentNodes.forEach((parentNode) => {
        let totalSum = 0;
        parentNode.classificationChildren.forEach((child) => {
            totalSum += child.totalExclVat;
        });
        parentNode.totalExclVat = totalSum;
    });

    const updatedNodes = [...tmpParentNodes];
    return updatedNodes;
};
